// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Open_Sans_30c501'","fontStyle":"normal"},"className":"__className_30c501","variable":"__variable_30c501"};